if ( typeof ImageHotspots !== 'function' ) {

	// Close every open tooltip on the page — not just one card's. Each card is
	// its own <image-hotspots> element, so scoping "close the other one" to a
	// single card let one tooltip stay open per card and pile up. Hoisted to the
	// module scope so a single document-level listener (bound once, next to the
	// element definition below) serves every card, instead of each instance
	// adding its own permanent listener that never got cleaned up.
	const closeAll = () => {
		document
			.querySelectorAll(".image-hotspots__spot--bullet.active")
			.forEach((open) => open.classList.remove("active"));
	};

  class ImageHotspots extends HTMLElement {

    constructor(){

      super();

			this.zIndex = 9;

      this.hotspots = this.querySelectorAll(
				".image-hotspots__spot--bullet"
			);

			this.hotspots.forEach((hotspot) => {
				// One tooltip at a time: clear all, then re-open the activated one
				// unless it was already open (so a second activation still closes it).
				const activate = (event) => {
					const bullet = event.currentTarget;
					const wasActive = bullet.classList.contains("active");
					closeAll();
					if (!wasActive) {
						bullet.classList.add("active");
						bullet.parentNode.style.zIndex = this.zIndex++;
					}
					event.stopPropagation();
				};

				hotspot.addEventListener("click", activate);

				// The bullet is a role="button" span, so make it keyboard-operable:
				// Enter/Space open the same tooltip (whose inner PDP link then becomes
				// tab-reachable via the .active CSS rule). preventDefault stops Space
				// from also scrolling the page.
				hotspot.addEventListener("keydown", (event) => {
					if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
						event.preventDefault();
						activate(event);
					}
				});
			});

    }

  }

  if ( typeof customElements.get('image-hotspots') == 'undefined' ) {
    customElements.define('image-hotspots', ImageHotspots);
    // A click anywhere else on the page closes any open tooltip. Bound exactly
    // once (gated by the same definition guard) rather than per instance.
    document.addEventListener("click", closeAll);
  }

}

if ( Shopify.designMode ) {
	document.addEventListener("shopify:block:select", (e) => {
		const block = e.target;
		if ( block.classList.contains("image-hotspots__spot") ) {
			const bulletElements = document.querySelectorAll(
				".image-hotspots__spot--bullet"
			);
			bulletElements.forEach((bulletElement) => {
				bulletElement.classList.remove("active");
			});
			const activeBullet = block.querySelector('.image-hotspots__spot--bullet');
			activeBullet.classList.add('active');
		}
	})
}